import { render, staticRenderFns } from "./WizardStepSelection.vue?vue&type=template&id=dfa3ffe2&scoped=true"
import script from "./WizardStepSelection.vue?vue&type=script&lang=js"
export * from "./WizardStepSelection.vue?vue&type=script&lang=js"
import style0 from "./WizardStepSelection.vue?vue&type=style&index=0&id=dfa3ffe2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfa3ffe2",
  null
  
)

export default component.exports